import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { updateChart } from '@/features/charts/api/update-chart';
import { useToast } from '@/shared/hooks/use-toast';

export const useUpdateChartMutation = () => {
  const { toast } = useToast();
  const { t } = useTranslation('chart', { keyPrefix: 'chart_creation' });

  return useMutation({
    mutationFn: updateChart,
    onError: (error) => {
      toast({
        title: t('errors.update_error'),
        description: error.message,
      });
    },
  });
};
